import React, { useState } from "react";
import style from "./index.module.scss";
import {
    Breadcrumb,
    Button,
    Divider,
    DatePicker,
    message,
    Tooltip
} from "antd";
import { BiUndo } from "react-icons/bi";
import moment from "moment";
import StuTable from "./components/StuTable";
import { getCloudInfoList, TableItem } from "../../../../service/experiment";
import { errorMessage } from "../../../../service/service";

interface ProjectListModalProps {
    isShow: boolean;
    onChange: () => void;
    projectName?: string;
    cloudGuid?: string;
    desktopCount?: number;
    nameLabel?: string;
}

export default function ProjectListModal({
    isShow,
    onChange,
    projectName,
    cloudGuid,
    desktopCount,
    nameLabel
}: ProjectListModalProps) {
    const { RangePicker } = DatePicker;
    const [startTime, setStartTime] = useState(""); //实验开始时间
    const [endTime, setEndTime] = useState(""); //实验结束时间
    const [list, setList] = useState<TableItem[]>([]); //资源列表
    const [selectData, setSelectData] = useState<TableItem[]>([]); //筛选列表
    const [loading, setLoading] = useState(false);

    async function handleSearch() {
        if (startTime === "" || endTime === "") {
            setList([]);
            message.warn("请选择需要查询的日期范围");
        } else {
            if (cloudGuid === undefined) return;

            setLoading(true);
            try {
                const list = await getCloudInfoList(
                    cloudGuid,
                    startTime,
                    endTime
                );
                setList(list.dataList);
                setSelectData(list.onSelect);
            } catch (e) {
                message.error(errorMessage(e));
            }
            setLoading(false);
        }
    }

    function onHandleBack() {
        onChange();
        setList([]);
        setSelectData([]);
    }

    return (
        <>
            {isShow && (
                <div className={style.root}>
                    <div className={style.container}>
                        <div className={style.header}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item onClick={onHandleBack}>
                                    <a href="#">新建实验计划</a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>查看资源情况</Breadcrumb.Item>
                            </Breadcrumb>

                            <Button
                                className={style.back}
                                onClick={onHandleBack}>
                                <BiUndo size={16} /> 返回
                            </Button>
                        </div>

                        <Divider />

                        <div className={style.info}>
                            <div className={style.left}>
                                <div className={style.title}>
                                    实验项目：
                                    <Tooltip title={projectName}>
                                        <span>{projectName}</span>
                                    </Tooltip>
                                    云桌面名称：
                                    <Tooltip title={nameLabel}>
                                        <span>{nameLabel}</span>
                                    </Tooltip>
                                </div>
                                <div className={style.num}>
                                    资源总数：<span>{desktopCount}</span>
                                </div>
                            </div>
                            <div className={style.right}>
                                <img
                                    src={require("./img/required.png")}
                                    alt=""
                                    className={style.requiredIcon}
                                />
                                {/*// @ts-ignore*/}
                                <RangePicker
                                    format="YYYY/MM/DD"
                                    onChange={dates => {
                                        if (dates.length !== 0) {
                                            setStartTime(
                                                moment(dates?.[0]).format(
                                                    "YYYY/MM/DD"
                                                )
                                            );
                                            setEndTime(
                                                moment(dates?.[1]).format(
                                                    "YYYY/MM/DD"
                                                )
                                            );
                                        } else {
                                            setStartTime("");
                                            setEndTime("");
                                        }
                                    }}
                                    className={style.rangePicker}
                                />
                                <Button
                                    type="primary"
                                    icon="search"
                                    className={style.searchBtn}
                                    onClick={handleSearch}>
                                    查询
                                </Button>
                            </div>
                        </div>
                        <StuTable
                            data={list}
                            selectData={selectData}
                            loading={loading}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
